<div
  class="card card-custom"
  [ngClass]="{ 'card-body-progress card-body-progress-overlay': viewLoading }"
>
  <div class="card-header" cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>
    <div class="card-title">
      <h3 class="card-label">{{ getTitle() }}</h3>
    </div>
    <button
      class="btn btn-sm btn-light btn-hover-secondary my-3"
      matTooltip="History"
      (click)="showHistory()"
    >
      <i class="fas fa-history p-0"></i>
    </button>
  </div>
  <form class="form" [formGroup]="prescriptionForm">
    <div class="navi-hover scroll card-body" [perfectScrollbar]="{ wheelPropagation: false }">
      <div class="card-body-progress">
        <mat-spinner [diameter]="20"></mat-spinner>
      </div>
      <kt-alert
        *ngIf="hasFormErrors"
        type="warn"
        [duration]="30000"
        [showCloseButton]="true"
        (closeAl)="onAlertClose()"
      >
        <span translate="GLOBAL.FORM_ERROR"></span>
      </kt-alert>
      <div class="form-group row">
        <div class="col-lg-11 kt-margin-bottom-20-mobile">
          <kt-general-autocomplete
            [label]="'Drug'"
            [loadItemsFunction]="drugAutocompleteCall"
            [optionFormatter]="filterDrugFn"
            [valueFormatter]="filterDrugFn"
            [required]="true"
            [readOnly]="isReadOnly"
            [control]="prescriptionForm.get('drug')"
            [change]="onDrugChange.bind(this)"
            [dataPath]="'data'"
            [placeholder]="'Select Drug'"
            #drugAutocomplete
          ></kt-general-autocomplete>
        </div>
        <button
          class="col-lg-1 kt-margin-bottom-20-mobile"
          mat-button
          matSuffix
          mat-icon-button
          aria-label="AddDrug"
          (click)="openDrugAddDialog()"
          *ngIf="!isReadOnly"
        >
          <mat-icon>add</mat-icon>
        </button>
        <div class="col-lg-11 kt-margin-bottom-20-mobile">
          <kt-general-autocomplete
            [label]="'Doctor'"
            [loadItemsFunction]="doctorAutocompleteCall"
            [optionFormatter]="stringUtils.autocompleteEntityFormatter"
            [valueFormatter]="stringUtils.displayName"
            [required]="true"
            [readOnly]="isReadOnly"
            [control]="prescriptionForm.get('doctor')"
            [change]="onDoctorChange.bind(this)"
            [dataPath]="'data'"
            [placeholder]="'Select Doctor'"
            #doctorAutocomplete
          ></kt-general-autocomplete>
        </div>
        <button
          class="col-lg-1 kt-margin-bottom-20-mobile"
          mat-button
          matSuffix
          mat-icon-button
          aria-label="AddDoctor"
          (click)="openDoctorAddDialog()"
          *ngIf="!isReadOnly"
        >
          <mat-icon>add</mat-icon>
        </button>
        <div class="col-lg-4 kt-margin-bottom-20-mobile">
          <mat-form-field class="mat-form-field-fluid" appearance="fill">
            <mat-label translate="PRESCRIPTION.FORM.PRESCRIBE_DATE">Prescribe date</mat-label>
            <input
              [owlDateTime]="dt1"
              matInput
              placeholder="Prescribe date"
              class="clendar-btn"
              formControlName="prescribe_date"
            />
            <owl-date-time #dt1 pickerType="calendar"></owl-date-time>
            <mat-icon class="clickable" [owlDateTimeTrigger]="dt1" matSuffix>access_time</mat-icon>
          </mat-form-field>
        </div>
        <div class="col-lg-4 kt-margin-bottom-20-mobile">
          <mat-form-field class="mat-form-field-fluid" appearance="fill">
            <mat-label translate="PRESCRIPTION.FORM.STOP_DATE">Stop date</mat-label>
            <input
              [min]="prescriptionForm.controls['prescribe_date'].value"
              [owlDateTime]="dt2"
              matInput
              placeholder="Stop date"
              class="clendar-btn"
              formControlName="stop_date"
            />
            <owl-date-time #dt2 pickerType="calendar"></owl-date-time>
            <mat-icon class="clickable" [owlDateTimeTrigger]="dt2" matSuffix>access_time</mat-icon>
          </mat-form-field>
        </div>
        <div class="col-lg-4 kt-margin-bottom-20-mobile">
          <mat-form-field class="mat-form-field-fluid" appearance="fill">
            <mat-label translate="PRESCRIPTION.FORM.EXPIRY_DATE">Expiry date</mat-label>
            <input
              [min]="prescriptionForm.controls['stop_date'].value"
              [owlDateTime]="dt3"
              matInput
              placeholder="Expiry date"
              class="clendar-btn"
              formControlName="expiry_date"
            />
            <owl-date-time #dt3 pickerType="calendar"></owl-date-time>
            <mat-icon class="clickable" [owlDateTimeTrigger]="dt3" matSuffix>access_time</mat-icon>
          </mat-form-field>
        </div>
        <div class="col-lg-4 kt-margin-bottom-20-mobile">
          <mat-form-field class="mat-form-field-fluid" appearance="fill">
            <mat-label translate="PRESCRIPTION.FORM.LAST_FILLED">Last Filled</mat-label>
            <input
              [owlDateTime]="dt4"
              matInput
              placeholder="Last Filled"
              class="clendar-btn"
              formControlName="last_filled_date"
            />
            <owl-date-time #dt4 pickerType="calendar"></owl-date-time>
            <mat-icon class="clickable" [owlDateTimeTrigger]="dt4" matSuffix>access_time</mat-icon>
          </mat-form-field>
        </div>
        <div class="col-lg-4 kt-margin-bottom-20-mobile">
          <mat-form-field appearance="fill" class="mat-form-field-fluid">
            <mat-label translate="PRESCRIPTION.FORM.DAYS_SUPPLY">Days Supply</mat-label>
            <input matInput type="number" formControlName="days_supply" />
          </mat-form-field>
        </div>
        <div class="col-lg-4 kt-margin-bottom-20-mobile">
          <mat-form-field appearance="fill" class="mat-form-field-fluid">
            <mat-label translate="PRESCRIPTION.FORM.QUANTITY">Quantity</mat-label>
            <input matInput type="number" formControlName="quantity" />
          </mat-form-field>
        </div>
        <div class="col-lg-4 kt-margin-bottom-20-mobile">
          <mat-form-field appearance="fill" class="mat-form-field-fluid">
            <mat-label translate="PRESCRIPTION.FORM.REFILL">Refill</mat-label>
            <input matInput type="number" formControlName="refill" />
          </mat-form-field>
        </div>
        <div class="col-lg-4 kt-margin-bottom-20-mobile">
          <mat-form-field appearance="fill" class="mat-form-field-fluid">
            <mat-label translate="PRESCRIPTION.FORM.ICD10">ICD10</mat-label>
            <input matInput formControlName="icd10" />
          </mat-form-field>
        </div>
        <div class="col-lg-4 kt-margin-bottom-20-mobile">
          <mat-form-field appearance="fill" class="mat-form-field-fluid">
            <mat-label translate="PRESCRIPTION.FORM.DIAGNOSIS_CODE">Diagnosis Code</mat-label>
            <input matInput formControlName="diagnosis_code" />
          </mat-form-field>
        </div>
        <div class="col-lg-12 kt-margin-bottom-20-mobile">
          <mat-form-field appearance="fill" class="mat-form-field-fluid">
            <mat-label translate="PRESCRIPTION.FORM.SIG">Sig</mat-label>
            <input matInput formControlName="sig" />
          </mat-form-field>
        </div>
        <div class="col-lg-12 kt-margin-bottom-20-mobile">
          <mat-form-field appearance="fill" class="mat-form-field-fluid">
            <mat-label translate="PRESCRIPTION.FORM.NOTE">Note</mat-label>
            <textarea matInput formControlName="note" maxlength="2000" rows="8"></textarea>
            <mat-hint align="end">{{ prescriptionForm.get('note').value?.length || 0 }}/2000</mat-hint>
            <mat-error *ngIf="prescriptionForm.get('note').hasError('maxlength')">
              Maximum length is 2000 characters
            </mat-error>
          </mat-form-field>
        </div>
        <div class="col-lg-2 kt-margin-bottom-20-mobile">
          <div class="checkbox-list">
            <label class="checkbox">
              <input type="checkbox" formControlName="is_hold" />
              <span></span>
              {{ 'PRESCRIPTION.FORM.IS_HOLD' | translate }}
            </label>
          </div>
        </div>
        <div class="col-lg-12 kt-margin-bottom-20-mobile" style="margin-top: 20px">
          <mat-form-field appearance="fill" class="mat-form-field-fluid">
            <mat-label translate="PRESCRIPTION.FORM.HOLD_REASON">Hold Reason</mat-label>
            <textarea matInput formControlName="hold_note" rows="3"></textarea>
          </mat-form-field>
        </div>
        <div class="col-lg-12 kt-margin-bottom-20-mobile">
          <div class="mat-form-field-fluid">
            <mat-label class="row ml-1" translate="DOCTOR.INPUT.STATUS">Status</mat-label>
            <mat-slide-toggle class="mr-2" formControlName="is_active"></mat-slide-toggle>
            <mat-hint align="start">
              <strong>{{ getStatusString() }}</strong>
            </mat-hint>
          </div>
        </div>
      </div>
    </div>
    <div class="card-footer">
      <div class="d-flex justify-content-between">
        <div class="mr-2"></div>
        <div>
          <button
            type="button"
            mat-raised-button
            [mat-dialog-close]="data.animal"
            cdkFocusInitial
            matTooltip="Cancel changes"
          >
            <span translate="GLOBAL.CANCEL">Cancel</span></button
          >&nbsp;
          <button
            *ngIf="!this.isReadOnly"
            type="button"
            mat-raised-button
            color="primary"
            (click)="onSubmit()"
            [disabled]="viewLoading"
            matTooltip="Save changes"
          >
            <span translate="GLOBAL.SAVE">Save</span>
          </button>
        </div>
      </div>
    </div>
  </form>
</div>
